// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newnew[data-v-24dab91b]{display:block;text-align:center}.newnew>img[data-v-24dab91b]{display:inline-block;top:2px;position:relative;margin:auto .5rem}", ""]);
// Exports
module.exports = exports;
